import { GenericPaymentsResponse } from 'src/types/payment';
import { PAYMENT_PROVIDER } from '../../constants';
import { resolveSuccessUrlSuffix } from '../utils';

const applyCertifiedPaymentsXmlTransform = (data: GenericPaymentsResponse) => {
  if (!data?.formData?.xmlTransaction) {
    return;
  }

  const baseUrl = window.location.href
    .replace(/\/$/g, '')
    .split('/')
    .slice(0, -1)
    .join('/');

  const successUrl = resolveSuccessUrlSuffix();
  data.formData.xmlTransaction = (data.formData.xmlTransaction as string)
    .replace(/DECKARD_PAYMENT_SUCCESS_URL/g, baseUrl + successUrl)
    .replace(/DECKARD_PAYMENT_CANCELLED_URL/g, baseUrl + '/dashboard')
    .replace(/DECKARD_PAYMENT_DUPLICATE_URL/g, baseUrl + '/dashboard');
};

export const handlePostRedirect = async (
  data: GenericPaymentsResponse,
  provider: PAYMENT_PROVIDER
) => {
  const form = document.createElement('form');

  form.setAttribute('method', 'POST');
  form.setAttribute('target', '_blank');
  form.setAttribute('rel', 'noreferrer noopener');
  form.setAttribute('action', data.url);

  if (provider === PAYMENT_PROVIDER.CERTIFIED_PAYMENTS) {
    applyCertifiedPaymentsXmlTransform(data);
  }

  for (const key in data.formData) {
    const inputElem = document.createElement('input');
    inputElem.setAttribute('type', 'hidden');
    inputElem.setAttribute('name', key);
    inputElem.setAttribute('value', data.formData[key] as string);
    form.appendChild(inputElem);
  }

  document.getElementsByTagName('body')[0].appendChild(form);
  form.submit();
};
